<ng-template #content>
  <ng-content />
</ng-template>

@if (state.isMobile) {
  @if (mobileTopPanel(); as panel) {
    <div #mobileTopPanelContainer>
      <ng-container *ngTemplateOutlet="panel" />
    </div>
  }
  <div class="mobile-view" [class.hidden]="state.isHidden">
    <ng-container *ngTemplateOutlet="sidenavContent; context: { $implicit: true }" />
  </div>
  <div
    class="shell-container-mobile"
    [class.has-top-panel]="hasMobileTopPanel()"
    [class.has-info-banner]="hasInfoBanner()"
    [style.--mobile-top-panel-height.px]="state.mobileTopPanelHeight"
  >
    <ng-container *ngTemplateOutlet="content" />
  </div>
} @else {
  <mat-sidenav-container class="shell-container" [class.has-info-banner]="hasInfoBanner()">
    <mat-sidenav
      [disableClose]="true"
      mode="side"
      [opened]="true"
      [class.sidenav-hidden]="state.isHidden"
      [class.sidenav-minimized]="state.isMinimized"
      [style.width.px]="state.width"
    >
      <ng-container *ngTemplateOutlet="sidenavContent; context: { $implicit: false }" />
    </mat-sidenav>
    <mat-sidenav-content class="sidenav-content bg-neutral-0 h-full" [style.margin-left.px]="state.width">
      <ng-container *ngTemplateOutlet="content" />
    </mat-sidenav-content>
  </mat-sidenav-container>
}

<ng-template #sidenavContent let-isMobile>
  <div
    class="sidenav-wrap"
    [class.is-compact]="state.isCompact || state.isMinimized"
    [class.is-minimized]="state.isMinimized"
    [class.is-mobile]="isMobile"
  >
    <div class="sidenav-inner flex h-full flex-col">
      <a [routerLink]="'/'" class="logo-link">
        @if (customLogo(); as logo) {
          <ng-container
            *ngTemplateOutlet="
              logo;
              context: { isCompact: state.isCompact || state.isMinimized, darkMode: state.darkMode }
            "
          />
        } @else {
          <dojo-app-logo
            [iconSrc]="logoCompact()"
            [iconSrcDark]="logoCompactDark()"
            [logoSrc]="logoFull()"
            [logoSrcDark]="logoFullDark()"
            [alt]="logoAlt()"
            [iconClass]="logoCompactClass()"
            [logoSecondClass]="logoFullClass()"
            [compact]="state.isCompact || state.isMinimized"
          />
        }
      </a>

      <div class="sidenav-inner-links" [class.new-mobile-menu]="isMobile" [class.more-menu-open]="isMoreMenuOpen()">
        @for (item of items(); track item.route) {
          <a
            class="sidebar-link additional-margin"
            [routerLink]="item.route"
            routerLinkActive="active"
            [attr.aria-label]="state.isCompact || state.isMinimized ? (item.labelKey | transloco) : null"
            (click)="isMobile && isMoreMenuOpen() && onMenuItemClick()"
          >
            <div class="sidebar-link-image">
              <dojo-icon
                [size]="30"
                [icon]="item.icon"
                [alt]="item.labelKey | transloco"
                [iconClass]="'feature-nav-icon feature-nav-icon--' + item.route"
              />
            </div>
            <span class="sidebar-link-text">{{
              (isMobile && item.labelKeyMobile ? item.labelKeyMobile : item.labelKey) | transloco
            }}</span>
          </a>
        }
        @if (!isMobile && !state.isMinimized) {
          @for (section of sections(); track section.id) {
            <div class="sidenav-section" role="group" [attr.aria-label]="section.labelKey | transloco">
              @if (state.isCompact) {
                <span class="sidenav-section-spacer"></span>
              } @else {
                <span class="sidenav-section-label">{{ section.labelKey | transloco }}</span>
              }
              @for (entry of section.entries; track entry.id) {
                <a
                  class="sidebar-link sidenav-entry"
                  [routerLink]="entry.route"
                  [class.active]="isEntryActive(entry)"
                  [attr.aria-current]="isEntryActive(entry) ? 'page' : null"
                  [attr.aria-label]="state.isCompact ? entry.label : null"
                >
                  <div class="sidebar-link-image">
                    <span class="sidenav-entry-avatar" [ngClass]="'sidenav-entry-avatar--' + entry.color">{{
                      entry.initial
                    }}</span>
                  </div>
                  <span class="sidebar-link-text truncate">{{ entry.label }}</span>
                </a>
              }
              @if (section.action; as action) {
                <a
                  class="sidebar-link sidenav-entry"
                  [routerLink]="action.route"
                  routerLinkActive="active"
                  [attr.aria-label]="state.isCompact ? (action.labelKey | transloco) : null"
                >
                  <div class="sidebar-link-image">
                    <span class="sidenav-entry-add"><dojo-icon [icon]="'plus'" [faPrefix]="'fas'" [size]="14" /></span>
                  </div>
                  <span class="sidebar-link-text truncate">{{ action.labelKey | transloco }}</span>
                </a>
              }
            </div>
          }
        }
        @if (isMobile && showMobileMoreButton()) {
          <button class="sidebar-link sidebar-link-more" [class.active]="isMoreMenuOpen()" (click)="onMoreClick()">
            <div class="sidebar-link-image">
              <dojo-icon
                [icon]="'ellipsis'"
                [ngClass]="isMoreMenuOpen() ? 'text-indigo-500' : 'text-neutral-200'"
                [size]="30"
              />
            </div>
            <span class="sidebar-link-text" [ngClass]="isMoreMenuOpen() ? '!text-primary' : 'text-secontary'">
              {{ 'examdojo.more' | transloco }}
            </span>
          </button>
        }
        @if (state.user && !(isMobile && showMobileMoreButton())) {
          <div class="flex grow flex-col justify-center gap-8 md:mt-auto md:grow-0 md:justify-start">
            @if (customFooter(); as footer) {
              <ng-container *ngTemplateOutlet="footer" />
            }
            @if (!isMobile && profile(); as profile) {
              <ng-container
                *ngTemplateOutlet="
                  profile;
                  context: { user: state.user, isCompact: state.isCompact || state.isMinimized }
                "
              />
            } @else {
              <dojo-sidebar-profile-link
                [user]="state.user"
                [settingsRoute]="settingsRoute()"
                (clicked)="navigateToProfile()"
              />
            }
          </div>
        }
      </div>
    </div>
  </div>
</ng-template>
